export default __webpack_public_path__ + "static/media/play-bg1.f916534c.jpg";